import classNames from 'classnames';
import { node, string, object, shape } from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import NamedLink from '../NamedLink/NamedLink';

import css from './Breadcrumbs.module.css';

const BreadcrumbsItem = ({ name, className, activeClassName, children, ...rest }) => {
  return (
    <NamedLink
      name={name}
      className={className}
      activeClassName={classNames(css.breadcrumbsItemActive, activeClassName)}
      {...rest}
    >
      {children || <FormattedMessage id={`Breadcrumbs.${name}`} />}
    </NamedLink>
  );
};

BreadcrumbsItem.defaultProps = {
  className: null,
  activeClassName: null,
  children: null,
  params: {},
  to: {},
  children: null,
  title: null,
};

BreadcrumbsItem.propTypes = {
  name: string.isRequired,
  className: string,
  activeClassName: string,
  params: object,
  to: shape({ search: string, hash: string, state: object }),
  title: string,
  children: node,
};

export default BreadcrumbsItem;
